// RowDetailsDrawer.js
import { CircularProgress, Drawer, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import Layout from "../utils/Layout";
import IngredientDetails from "./IngredientDetails";
import { useNavigate } from "react-router-dom";
import AlertBar from "../utils/AlertBar";
import { API_URL } from "../../config/environment";
import { useAnalyticsEventTracker } from "../utils/useAnalyticsEventTracker";

export default function IngredientsDetailsDrawer({
  isOpen,
  onClose,
  selectedRowId,
  selectedIngredient,
  view_from,
  userId,
}) {
  const navigate = useNavigate();
  const eventTracker = useAnalyticsEventTracker();

  const [loading, setLoading] = useState(true);
  const [ingredient, setIngredient] = useState(null);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const token = sessionStorage.getItem("authToken");

  const handleIsErrorState = () => setIsError(false);

  const getIngredient = async (id, url) => {
    if (!id || !url) return null;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 401) {
        navigate("/signin");
        return null;
      }

      const data = await response.json();

      if (data.status === "success") {
        const ingredient = data.ingredient;
        eventTracker("ingredient_view", {
          view_from,
          ingredient: ingredient?.ingredient,
          code: ingredient?.code,
          technofunctionality: ingredient?.technofunctionality,
          user_id: userId,
        });
        return ingredient;
      } else {
        console.log("Could not fetch data from the server");
        onClose();
        setIsError(true);
        setErrorMessage(data.message);

        return null;
      }
    } catch (error) {
      console.error("Error fetching ingredients:", error);
      onClose();
      return null;
    }
  };

  const fetchData = async (id, url) => {
    const ingredient = await getIngredient(id, url);
    setIngredient(ingredient);
    setLoading(false);
  };

  useEffect(() => {
    if (selectedRowId) {
      const url = `${API_URL}/ingredients/${
        selectedIngredient || selectedRowId
      }`;
      fetchData(selectedRowId, url);
    } else {
      const url = `${API_URL}/ingredients/${selectedIngredient}`;
      fetchData(selectedIngredient, url);
    }
  }, [selectedRowId, selectedIngredient]);

  return (
    <>
      <Drawer anchor="right" open={isOpen} onClose={onClose}>
        <div style={{ width: 700, padding: 16 }}>
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            <Layout>
              <Grid container spacing={0} columns={16}>
                {ingredient ? (
                  <IngredientDetails ingredient={ingredient} />
                ) : (
                  <p>No ingredient details available</p>
                )}
              </Grid>
            </Layout>
          )}
        </div>
      </Drawer>

      <AlertBar
        open={isError}
        message={errorMessage}
        severity="error"
        onClose={handleIsErrorState}
      />
    </>
  );
}
